import React, {useEffect, useState} from "react";
import DeliveryMetaCard from "../MetaCard";
import merchant from "../../network/services/merchant";
import {getCourierBusinessId} from "../../helpers/authenticator";
import quick_models from "../../network/models/quick_models";
import Loader from "react-loaders";


const Sider = ({data}) => {
    const [stats, setStats] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        merchant.getRiderStats(getCourierBusinessId(), data.id).then(response => {
            setStats(response.data.data);
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, []);
    let mergedStats = {...quick_models.riderStatsResponse, ...stats};

    return (
        <>
            {isLoading ? <Loader type="ball-scale-multiple"/> : <div className="col-md-3">
                <ul className="list-unstyled">
                    <li>
                        <DeliveryMetaCard
                            data={{title: data.agent.name, subTitle: data.agent.phone}}/>
                    </li>
                    <li>
                        <div className="card text-center">
                            <ul className="list-unstyled">
                                <li><h4>{mergedStats.total_amount_payable}</h4></li>
                                <li>
                                    <hr/>
                                </li>
                                <li>
                                    <small>Amount Due (GHS)</small>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <button className="btn btn-primary btn-md btn-block" data-toggle="modal"
                                data-target="#decisionModal">
                            Payout
                        </button>
                    </li>
                </ul>
            </div>}
        </>
    );
};

export default Sider;
